module.exports = new __parcel__URL__("clock-with-question-mark.4f9f0a32.svg").toString();